module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }